import api from '../../../../services/apiClient';



export async function getKindergartensList({period, near_address, search, filters, search_by, internationalAgreement}){

    const endpoint = `kindergartens/list`;

    const parameters = [];

    if(period && period !== "all") parameters.push(`period_start=${period}`);

    if(near_address) parameters.push(`near_address=${near_address}`);
    if(near_address) parameters.push(`radius=0.01`);
    if(search) parameters.push(`search=${search}`);
    if(search_by) parameters.push(`search_by=${search_by}`);
    if(internationalAgreement) parameters.push(`international_agreement=true`);

    Object.keys(filters).forEach((f)=>{
        const arrF = [];

        if(Array.isArray(filters[f]) ) return parameters.push(`${f}=${filters[f].join(",")}`);

        Object.keys(filters[f]).forEach((r)=>{
            if(filters[f][r]) arrF.push(r);
        });

        if(arrF.length) parameters.push(`${f}=${arrF.join(",")}`);
    });

    const info = await api.get(endpoint + ( parameters.length > 0 ? `?${parameters.join("&")}` : '') );

    return info && info.data;

}